import { useEffect, useState, useContext, useRef } from "react";
import GridBody from "./grid/grid-body";
import SidePanel from "./grid/side-panel";
import DateButtons from "./grid/date-buttons";
import TimeBar from "./grid/time-bar";
import { getAnalyticTags } from "core/lib/analytics-methods";
import NewsArticles from "./shared/news-article";
import context from "core/tv-guide.context";
import { observer } from "mobx-react-lite";
import { AppContext } from "core/providers/tv-guide.context";
import GridDataContext from "core/providers/grid-data-context";
import Loader from "./loader/loader";
import ChannelBlock from "./grid/channels-block";
import { useForceUpdate } from "@menu/core/hooks";

const TVGuideGrid = observer(() => {
  const gridContext = useContext(GridDataContext);

  const appContext = useContext(AppContext);
  const store = appContext.store;

  const [scrollX, setScrollX] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [timeWidth, setTimeWidth] = useState(0);
  const isLoaded = useRef<boolean>(false);
  // const [singleChannel, setSingleChannel] = useState(false);

  const forceUpdate = useForceUpdate();

  const dictionary = context.dictionary;

  useEffect(() => {
    if (!store.dateTime || !gridContext.dimensionBlock) {
      return;
    }

    const { hours, minutes } = store.dateTime;
    const width =
      hours * 60 * gridContext.dimensionBlock.minuteWidth +
      minutes * gridContext.dimensionBlock.minuteWidth;

    setTimeWidth(width);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    store.currentTime,
    store.dateTime,
    gridContext.dimensionBlock
  ]);

  //Needed?
  // useEffect(() => {
  //   if (!store.schedule) {
  //     return;
  //   }

  //   // store.updateFavouriteChannelNumbers(props.shortChannelList);

  //   const isUpdated = props.shortChannelList.length > 0;
  //   setGridUpdate(isUpdated);

  //   const rootEl = document.getElementById('tvg-root') as HTMLElement;
  //   const shortChannels = rootEl.getAttribute('data-channel-shortlist');

  //   if (shortChannels && shortChannels.length) {
  //     setSingleChannel(true);
  //   }
  // }, [
  //   props.shortChannelList,
  //   store.schedule
  // ]);

  useEffect(() => {
    if (isLoaded.current === true || !store.hasScheduleData) {
      return;
    }

    const timeOutMs = 300;

    setTimeout(() => {
      isLoaded.current = true;
      //Without forceUpdate() there can be a noticeable delay before showing the grid
      forceUpdate();
      console.debug("Grid Loaded");
    }, timeOutMs);
  }, [store.hasScheduleData]);

  const onQuickGenreLinkClickHandle = (item: string) => {
    const genre = store.genres.find(x => x.mainGenre === item);
    const genreValue = (genre?.value || genre?.mainGenre) ?? "";
    appContext.updateGenre(genreValue);
  }

  if (!isLoaded.current) {
    return <Loader />
  }

  console.debug("Rendering Grid");

  return (
    <>
      <ChannelBlock
        store={gridContext}
        dimensionBlock={gridContext?.dimensionBlock}
        scrollParams={gridContext?.scrollParams} />

      {gridContext.dimensionBlock && <section>
        {/* {!singleChannel && ( */}
        <div className="grid-header">
          <DateButtons
            setScrollX={setScrollX}
            dateIndex={gridContext.dateIndex}
            horizontalScrollIndexes={gridContext.horizontalScrollIndexes} />
        </div>
        {/* )} */}
        {
          context.fifaWorldCup && (
            <div className="fifa-world-cup-quick-link quick-link-grid-view">
              <p>{dictionary.fifaWorldCupLinkText}<span {...getAnalyticTags({
                component_name: "fifa_quick_link_genre_selected",
                component_type: "genre_selected",
                genre_type: "FIFA World Cup",
              })} onClick={() => onQuickGenreLinkClickHandle("FIFA World Cup")}>{` ${dictionary.clickHere}`}</span></p>
            </div>
          )
        }
        <div className="channel-time-bar">
          <div className="channel-block floating-block" id="channelBlock">
            {dictionary.channels}
          </div>
          <TimeBar setScrollX={setScrollX} scrollX={scrollX} />
        </div>
        <SidePanel
          setScrollY={setScrollY}
          scrollY={scrollY}
          dateItemArr={store.dateTime}
        />

        <GridBody
          setScrollX={setScrollX}
          setScrollY={setScrollY}
          dates={store.dates}
          dimensionBlock={gridContext.dimensionBlock}
          timeWidth={timeWidth}
          gridScrollIndexes={gridContext.gridScrollIndexes}
          scrollX={scrollX}
          scrollY={scrollY} />
        {
          context.showNewsArticles && (
            <NewsArticles articles={store.newsArticles} loading={store.isFetching} />
          )
        }
      </section>}
    </>
  );
});

export default TVGuideGrid;
